export default {
  promotional_text: 'Spar tid og optjen belønninger!',
  description:
    '{{name}}-appen er her – til endnu nemmere bestilling:\n\n• Superhurtig bestilling via appen\n\n• Øjeblikkelige notifikationer om tilbud og belønninger\n\n• Saml og indløs dine point nemt\n\n• Følg status på din ordre i realtid\n\nVi er glade for at kunne tilbyde dig vores app – og håber, at du får lige så meget glæde af den som os!`',
  keywords: 'Mobilbestilling, Restaurantapp, Madapp, Afhentning, Bestil mad, Takeaway, Leveringsservice',
};
